import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';
import { FranchiseeView } from '../../dealer/view/franchisee-view';
import { html } from 'lit';
import { PageBase } from './helpers/page-base';
import { tlang } from '../../../webmodule-common/other/language/lang';
import { userDataStore } from '../common/current-user-data-store';

@customElement('app-dealers')
export class AppDealers extends PageBase {
  @state()
  dealerView: FranchiseeView | null = null;

  constructor() {
    super();
  }
  async dispose() {
    await super.dispose();
    await disposeOf(this.dealerView);
    this.dealerView = null;
  }

  render() {
    if (!this.loggedIn) return html``;
    return html` <div class="page-content">
      <div class="page-container">${this.dealerView?.ui}</div>
    </div>`;
  }

  meta() {
    return {
      title: tlang`%%franchisee-network%%`,
      description: tlang`%%franchisee-network%% settings page`
    };
  }

  protected async canLeavePage(): Promise<boolean> {
    if (this.dealerView) return await this.dealerView.canClose();
    else return true;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async dealerViewFactory(): Promise<FranchiseeView> {
    return await constructAsync(new FranchiseeView());
  }

  protected async afterUserConnected() {
    //we need to flush the user data store any time we come to this page in case it is stale information
    await userDataStore.reLoadGlobalSupplier();
    this.dealerView = await this.dealerViewFactory();
  }
}
